import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { IStorageLocal } from "namirasoft-core";
import { RegionRow } from "namirasoft-nws-region";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, DateTimeFormatter, IDFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";

import { NWSRegionRouterProps } from "./NWSRegionRouterProps";
import { NWSRegionRoutes } from "./NWSRegionRoutes";

export class NWSRegionEntities
{
    static region(props: NSARouterMakerResult & NWSRegionRouterProps): IEntityInfo<RegionRow, RegionRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, props.notifier.onError);

        return {
            product_id: ProductUUID.NAMIRASOFT_NWS_REGION,
            name: "region",
            tables: [{ table: namirasoft.nws_region.tables.region, required: true }],
            client: {
                getListURL: () => NWSRegionRoutes.RegionList,
                getViewURL: (id: string) => NWSRegionRoutes.RegionView(id),
                getNewURL: null,
                getCopyURL: null,
                getEditURL: null,
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.nws_region.tables.region.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.nws_region.tables.region.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.nws_region.tables.region.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.nws_region.tables.region.columns.provider, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.nws_region.tables.region.columns.country, new StringFormatter(StringFormatterSizeType.FullName)),
                        BaseColumnFormatter.getColumn(namirasoft.nws_region.tables.region.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.nws_region.tables.region.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.nws_region.tables.region.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
            },
            server: {
                value_list: props.servers.nws_region.value.List,
                list: props.servers.nws_region.region.List,
                get: props.servers.nws_region.region.Get,
                create: null,
                update: null,
                delete: null,
            }
        };
    }
}